import Backbone from "backbone";
import _ from "underscore";
import {UnitModel} from "./unit-model";
import {date, sort, rent} from "utils";

const UnitCollection = Backbone.Collection.extend({
    model: UnitModel,
    comparator: function(a, b) {
        let value = sort.modelNumeric("available_date", a, b);

        if (value === 0) {
            value = sort.modelNumeric("bed", a, b);

            if (value === 0) {
                value = sort.modelNumeric("bath", a, b);

                if (value === 0) {
                    value = sort.modelNatural("number", a, b);
                }
            }
        }

        return value;
    },
    parse: function(models, options) {
        const now = Date.now();
        let units = _.map(models, function(unit) {
            let day = date.parse(unit.available_date),
                avail = options.availableString;

            if (!avail) {
                avail = "Available NOW!";
            }

            unit.available_date = day;
            unit.available_label = avail;
            if (day >= now) {
                unit.available_label = date.format(day);
            }

            unit.rentValues = rent.valuesFromString(unit.rent);

            if (unit.promo_description_expiration !== null) {
                unit.promo_description_expiration = date.parse(unit.promo_description_expiration);
            }

            if (options.deepLinksEnabled && unit.realpage_api_id) {
                const moveInDate = new Date(Math.max(day, now));
                unit.availability_link = `/onlineleasing/?MoveInDate=${date.format(moveInDate)}&SearchUrl=/floorplans/&UnitId=${unit.realpage_api_id}`;
            }

            return unit;
        });

        return units;
    }
});

export {UnitCollection};
